import { useEffect } from 'react';
import { TimerType, useTimer } from '@carnica/utils/hooks';
import { useTopBarColor } from "../../../../hooks/useTopBarColor";
var viewsMap = {
  info: '#E2E6ED',
  success: '#00C06D',
  error: '#FF6524',
  warning: '#FFD546'
};
export var useSnackBarItem = function useSnackBarItem(_ref) {
  var onClose = _ref.onClose,
    autoCloseTime = _ref.autoCloseTime,
    mode = _ref.mode,
    view = _ref.view;
  var timer = useTimer({
    endTime: 0,
    startTime: autoCloseTime,
    timerType: TimerType.DECREMENTAL,
    onTimeOver: onClose
  });
  useTopBarColor(viewsMap[view]);
  var pause = function pause() {
    if (mode === 'autoclose') {
      timer.pause();
    }
  };
  var play = function play() {
    if (mode === 'autoclose') {
      timer.start();
    }
  };
  useEffect(function () {
    play();
  }, [mode]);
  return {
    pause: pause,
    play: play
  };
};